<template>
  <div class="crm-page">
    <div class="crm-hero">
      <div>
        <div class="crm-eyebrow">客户管理CRM</div>
        <h2>规则设置</h2>
        <p>
          统一配置首次跟进、加微信、私人池、公海池、重复客户与质检规则。本阶段只演示前端配置中心，不接真实后端。
        </p>
      </div>
      <div class="crm-actions">
        <el-button icon="el-icon-refresh-left" @click="restoreDefault"
          >恢复默认设置</el-button
        >
        <el-button type="primary" icon="el-icon-check" @click="saveRules"
          >保存设置</el-button
        >
      </div>
    </div>

    <div class="top-tip">
      当前仅前端展示，保存规则后端待接入。这里先确认规则项、文案、默认值和交互形式。
    </div>

    <div class="rule-grid">
      <el-card shadow="never" class="rule-card">
        <div slot="header">A. 首次跟进规则</div>
        <div class="rule-row">
          <span>新客户多久内必须首次联系</span
          ><el-input-number
            v-model="rules.firstFollow.requiredWithinHours"
            :min="1"
            :max="240"
          ></el-input-number
          ><b>小时</b>
        </div>
        <div class="rule-row">
          <span>超期多久提醒</span
          ><el-input-number
            v-model="rules.firstFollow.remindAfterHours"
            :min="1"
            :max="240"
          ></el-input-number
          ><b>小时</b>
        </div>
        <div class="rule-row">
          <span>超期多久转公海</span
          ><el-input-number
            v-model="rules.firstFollow.publicAfterHours"
            :min="1"
            :max="240"
          ></el-input-number
          ><b>小时</b>
        </div>
      </el-card>

      <el-card shadow="never" class="rule-card">
        <div slot="header">B. 微信添加规则</div>
        <div class="rule-row">
          <span>标记有意向后多久内必须添加微信</span
          ><el-input-number
            v-model="rules.wechat.mustAddWithinHours"
            :min="1"
            :max="240"
          ></el-input-number
          ><b>小时</b>
        </div>
        <div class="rule-row">
          <span>超期提醒时间</span
          ><el-input-number
            v-model="rules.wechat.remindAfterHours"
            :min="1"
            :max="240"
          ></el-input-number
          ><b>小时</b>
        </div>
        <div class="rule-row">
          <span>超期转公海时间</span
          ><el-input-number
            v-model="rules.wechat.publicAfterHours"
            :min="1"
            :max="240"
          ></el-input-number
          ><b>小时</b>
        </div>
      </el-card>

      <el-card shadow="never" class="rule-card">
        <div slot="header">C. 私人池规则</div>
        <div class="rule-row">
          <span>多少天未跟进提醒</span
          ><el-input-number
            v-model="rules.privatePool.remindAfterDays"
            :min="1"
            :max="60"
          ></el-input-number
          ><b>天</b>
        </div>
        <div class="rule-row">
          <span>多少天未跟进自动转公海</span
          ><el-input-number
            v-model="rules.privatePool.publicAfterDays"
            :min="1"
            :max="60"
          ></el-input-number
          ><b>天</b>
        </div>
        <div class="rule-row full">
          <span>高意向客户是否独立规则</span
          ><el-switch
            v-model="rules.privatePool.highIntentIndependent"
          ></el-switch>
        </div>
      </el-card>

      <el-card shadow="never" class="rule-card">
        <div slot="header">D. 已加微信未签约规则</div>
        <div class="rule-row">
          <span>高意向客户提醒天数</span
          ><el-input-number
            v-model="rules.signedDelay.highIntentRemindDays"
            :min="1"
            :max="60"
          ></el-input-number
          ><b>天</b>
        </div>
        <div class="rule-row">
          <span>高意向转公海天数</span
          ><el-input-number
            v-model="rules.signedDelay.highIntentPublicDays"
            :min="1"
            :max="60"
          ></el-input-number
          ><b>天</b>
        </div>
        <div class="rule-row">
          <span>中意向转公海天数</span
          ><el-input-number
            v-model="rules.signedDelay.mediumIntentPublicDays"
            :min="1"
            :max="60"
          ></el-input-number
          ><b>天</b>
        </div>
        <div class="rule-row">
          <span>低意向转公海天数</span
          ><el-input-number
            v-model="rules.signedDelay.lowIntentPublicDays"
            :min="1"
            :max="60"
          ></el-input-number
          ><b>天</b>
        </div>
      </el-card>

      <el-card shadow="never" class="rule-card">
        <div slot="header">E. 公海池规则</div>
        <div class="rule-row">
          <span>每人每天可领取数量</span
          ><el-input-number
            v-model="rules.publicPool.dailyClaimLimit"
            :min="1"
            :max="99"
          ></el-input-number
          ><b>条</b>
        </div>
        <div class="rule-row">
          <span>领取后保护期天数</span
          ><el-input-number
            v-model="rules.publicPool.protectDays"
            :min="1"
            :max="30"
          ></el-input-number
          ><b>天</b>
        </div>
        <div class="rule-row full">
          <span>保护期内是否允许他人查看</span
          ><el-switch
            v-model="rules.publicPool.visibleDuringProtect"
          ></el-switch>
        </div>
        <div class="rule-row full">
          <span>保护期内无跟进是否自动退回</span
          ><el-switch
            v-model="rules.publicPool.noFollowBackToPublic"
          ></el-switch>
        </div>
      </el-card>

      <el-card shadow="never" class="rule-card">
        <div slot="header">F. 重复客户规则</div>
        <div class="rule-row full">
          <span>以手机号为唯一主键</span
          ><el-switch v-model="rules.duplicate.phoneAsPrimaryKey"></el-switch>
        </div>
        <div class="rule-row full">
          <span>微信号重复提醒</span
          ><el-switch v-model="rules.duplicate.wechatDupWarn"></el-switch>
        </div>
        <div class="rule-row full">
          <span>是否允许重复创建</span
          ><el-switch
            v-model="rules.duplicate.allowDuplicateCreate"
          ></el-switch>
        </div>
      </el-card>

      <el-card shadow="never" class="rule-card">
        <div slot="header">G. 质检规则</div>
        <div class="rule-row">
          <span>跟进记录最少字数</span
          ><el-input-number
            v-model="rules.quality.minFollowTextLength"
            :min="10"
            :max="500"
          ></el-input-number
          ><b>字</b>
        </div>
        <div class="rule-row full">
          <span>是否必须填写下次跟进时间</span
          ><el-switch v-model="rules.quality.requireNextFollow"></el-switch>
        </div>
        <div class="rule-row full">
          <span>是否必须上传截图/录音</span
          ><el-switch v-model="rules.quality.requireEvidence"></el-switch>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { loadCrmState, saveCrmState } from "./mock";

function defaultRules() {
  return {
    firstFollow: {
      requiredWithinHours: 24,
      remindAfterHours: 12,
      publicAfterHours: 48,
    },
    wechat: {
      mustAddWithinHours: 48,
      remindAfterHours: 24,
      publicAfterHours: 72,
    },
    privatePool: {
      remindAfterDays: 3,
      publicAfterDays: 7,
      highIntentIndependent: true,
    },
    signedDelay: {
      highIntentRemindDays: 5,
      highIntentPublicDays: 10,
      mediumIntentPublicDays: 15,
      lowIntentPublicDays: 7,
    },
    publicPool: {
      dailyClaimLimit: 8,
      protectDays: 5,
      visibleDuringProtect: false,
      noFollowBackToPublic: true,
    },
    duplicate: {
      phoneAsPrimaryKey: true,
      wechatDupWarn: true,
      allowDuplicateCreate: false,
    },
    quality: {
      minFollowTextLength: 20,
      requireNextFollow: true,
      requireEvidence: false,
    },
  };
}

function clone(data) {
  return JSON.parse(JSON.stringify(data));
}

export default {
  name: "CrmRules",
  data() {
    const state = loadCrmState(this.$store.getters.GET_TITLE || "当前员工");
    return {
      state,
      rules: clone(state.rules || defaultRules()),
    };
  },
  methods: {
    saveRules() {
      this.state.rules = clone(this.rules);
      saveCrmState(this.state);
      this.$message.success("规则设置已保存到前端 mock 数据（后端待接入）");
    },
    restoreDefault() {
      this.rules = defaultRules();
      this.$message.success("已恢复默认规则配置");
    },
  },
};
</script>

<style scoped>
.crm-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.crm-hero {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 24px 28px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #e8edf5;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.04);
}
.crm-eyebrow {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(64, 158, 255, 0.12);
  color: #409eff;
  font-size: 12px;
  font-weight: 700;
}
.crm-hero h2 {
  margin: 12px 0 0;
  font-size: 28px;
  color: #111827;
}
.crm-hero p {
  margin: 10px 0 0;
  color: #6b7280;
  line-height: 1.7;
}
.crm-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.top-tip {
  padding: 14px 16px;
  border-radius: 14px;
  background: #fff8eb;
  border: 1px dashed #f5d38b;
  color: #9a6700;
  line-height: 1.8;
}
.rule-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
.rule-card {
  border-radius: 18px;
}
.rule-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 120px 28px;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #eef2f7;
}
.rule-row.full {
  grid-template-columns: minmax(0, 1fr) 80px;
}
.rule-row:last-child {
  border-bottom: none;
}
.rule-row span {
  color: #374151;
  line-height: 1.6;
}
.rule-row b {
  color: #9ca3af;
  font-weight: 500;
}
@media (max-width: 1200px) {
  .crm-hero {
    flex-direction: column;
    align-items: flex-start;
  }
  .rule-grid {
    grid-template-columns: 1fr;
  }
}
</style>
